import React from 'react';
import PropTypes from 'prop-types';
import TimelineItem from '@mui/lab/TimelineItem';

const UiTimelineItem = ({ children, ...props }) => {
  return <TimelineItem {...props}>{children}</TimelineItem>;
};

UiTimelineItem.propTypes = {
  children: PropTypes.array,
};

export default UiTimelineItem;
